export function ensureAuxStructures2(processedGraph) {
    if (!processedGraph) {
        throw new Error("processedGraph is undefined");
    }
    if (processedGraph.aux === undefined) {
        processedGraph.aux = {
            getNodeById: (nodeId) => getNodeById(processedGraph, nodeId),
            getEdgesByFrom: (edgeFrom) => getEdgesByFrom(processedGraph, edgeFrom),
            getEdgesByTo: (edgeTo) => getEdgesByTo(processedGraph, edgeTo),
        };
    }
    if (!processedGraph.aux.getNodeById || !processedGraph.aux.getEdgesByFrom || !processedGraph.aux.getEdgesByTo) {
        recreateAuxStructures2(processedGraph);
        return;
    }
    if (!processedGraph.aux.idToNodeMap) {
        processedGraph.aux.idToNodeMap = makeIdToNodeMap(processedGraph);
    }
    if (!processedGraph.aux.fromIdToEdgesMap) {
        processedGraph.aux.fromIdToEdgesMap = makeFromIdToEdgesMap(processedGraph);
    }
    if (!processedGraph.aux.toIdToEdgesMap) {
        processedGraph.aux.toIdToEdgesMap = makeToIdToEdgesMap(processedGraph);
    }
    if (!processedGraph.aux.idToCidMap) {
        processedGraph.aux.idToCidMap = makeIdToCidMap(processedGraph);
    }
}
export function recreateAuxStructures2(processedGraph) {
    if (!processedGraph) {
        throw new Error("processedGraph is undefined");
    }
    delete processedGraph.aux;
    ensureAuxStructures2(processedGraph);
}
function makeIdToNodeMap(processedGraph) {
    const map = {};
    for (const node of processedGraph.nodes) {
        map[node.id] = node;
    }
    return map;
}
function makeFromIdToEdgesMap(processedGraph) {
    const map = {};
    for (const rel of processedGraph.edges) {
        if (map[rel.from] === undefined) {
            map[rel.from] = [];
        }
        map[rel.from].push(rel);
    }
    return map;
}
function makeToIdToEdgesMap(processedGraph) {
    const map = {};
    for (const rel of processedGraph.edges) {
        if (map[rel.to] === undefined) {
            map[rel.to] = [];
        }
        map[rel.to].push(rel);
    }
    return map;
}
function makeIdToCidMap(processedGraph) {
    const map = {};
    for (const node of processedGraph.nodes) {
        if (node.cid) {
            map[node.id] = node.cid;
        }
    }
    return map;
}
function getNodeById(processedGraph, nodeId) {
    return processedGraph.aux?.idToNodeMap?.[nodeId];
}
function getEdgesByFrom(processedGraph, edgeFrom) {
    return processedGraph.aux?.fromIdToEdgesMap?.[edgeFrom] ?? [];
}
function getEdgesByTo(processedGraph, edgeTo) {
    return processedGraph.aux?.toIdToEdgesMap?.[edgeTo] ?? [];
}
